import { NgModule } from '@angular/core';

import { ScrollTargetDirective } from './ScrollTarget.directive';

@NgModule({
  imports: [],
  declarations: [ScrollTargetDirective],
  exports: [ScrollTargetDirective],
})
export class ScrollTargetDirectiveModule {}
